import React, { useEffect, useMemo } from 'react';
import PublicHeader from '../../components/ui/PublicHeader';
import PublicFooter from '../../components/ui/PublicFooter';
import { paymentCallback } from '../../api/paymentCallback';
import Toast from '../../components/ui/Toast';
import { useToast } from '../../hooks/useToast';

const PaymentCallback = () => {
  const { toast, showToast, hideToast } = useToast(3000);
  const query = useMemo(() => {
    if (typeof window === 'undefined') return null;
    return new URLSearchParams(window.location.search);
  }, []);

  useEffect(() => {
    if (!query || query.size == 0) return;
    const run = async () => {
      try {
        const redirectUrl = await paymentCallback(query);
        if (redirectUrl) window.location.assign(redirectUrl);
      } catch (error) {
        showToast(`پردازش دچار مشکل شد. ${error}`, 'error');
        console.error('Payment callback failed:', error);
      }
    };

    run();
  }, [query]);

  return (
    <>
      <Toast
        visible={toast.visible}
        message={toast.message}
        type={toast.type}
        onClose={hideToast}
      />
      <div
        className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50"
        dir="rtl"
      >
        <PublicHeader />

        <main className="container mx-auto max-w-4xl px-4 py-16">
          <section className="mx-auto max-w-3xl">
            <div className="rounded-3xl border border-white/70 bg-white/80 px-6 py-10 shadow-xl backdrop-blur-md sm:px-10 sm:py-12">
              <div className="mx-auto flex max-w-2xl flex-col items-center text-center">
                <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-purple-100">
                  <div className="h-10 w-10 rounded-full border-4 border-t-transparent animate-spin border-purple-500" />
                </div>
                <h1 className="text-3xl font-light leading-tight text-gray-800 sm:text-5xl">
                  لطفاً کمی صبر کنید
                </h1>

                <p className="mt-5 max-w-2xl text-base leading-8 text-gray-600 sm:text-lg">
                  در حال بررسی پرداخت شما هستیم...
                </p>

                <div className="mt-8 w-full rounded-3xl bg-gradient-to-r from-purple-600 to-pink-600 px-6 py-6 text-white shadow-lg">
                  <p className="text-lg leading-9 sm:text-xl">
                    لطفاً این صفحه را نبندید. نتیجه پرداخت در حال پردازش است.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <PublicFooter />
      </div>
    </>
  );
};

export default PaymentCallback;
